



















import { defineComponent } from '@nuxtjs/composition-api'
import { StepProtocol } from '~/types/product/productTypes'
export default defineComponent({
  props: {
    kitUsageInformation: {
      type: Array as () => Object[],
      required: false,
      default: undefined,
    },
    protocols: {
      type: Object as () => { [key: string]: StepProtocol },
      required: false,
      default: undefined,
    },
  },
  setup({ kitUsageInformation, protocols }) {
    let kitUsageInformationData = [] as Array<{
      number: string
      aliasAndNumber: Object
    }>

    if (kitUsageInformation) {
      kitUsageInformationData = kitUsageInformation
        .reduce((kit: any, current: any) => {
          kit.push({
            number: current.number,
            aliasAndNumber: (() => {
              const data = [] as Object[]
              current.lot?.applications?.application.forEach((app: any) => {
                if (app.protocol) {
                  const number = app.protocol.number
                  data.push({
                    alias: protocols[number].alias,
                    number,
                  })
                }
              })
              return data
            })(),
          })

          return kit
        }, [] as Object[])
        .sort((kitA: any, kitB: any) => kitA.number - kitB.number)
    }

    return { kitUsageInformationData }
  },
})
